@if (content(); as content) {
  <section class="flex flex-col gap-4 xl:gap-6">
    <app-content-images
      class="overflow-hidden"
      [imageUrls]="content.imageUrls"
    />

    <div class="flex flex-col gap-3 p-4 xl:p-0">
      <div class="flex w-full justify-between items-center">
        <div class="px-2 py-1 rounded-lg bg-gray-100 text-gray-500 text-xs">
          {{ categoryName() }}
        </div>
        <div class="flex gap-3 items-center">
          <app-content-favorite
            (favorite)="handleFavorite()"
            [isFavorite]="isFavorite()"
          />
          <app-content-share [title]="content.title" />
        </div>
      </div>
      <p class="text-gray-800 font-semibold text-lg xl:text-xl">
        {{ content.title }}
      </p>
      <p class="text-gray-600" [innerHTML]="content.content"></p>

      <div class="flex w-full justify-between items-center *:text-gray-600">
        <p class="xl:text-base text-sm">
          {{ content.eventAt | date: 'y.MM.dd' }}
        </p>
        <p>조회수 {{ content.viewCount | number }}</p>
      </div>

      @if (content?.documentUrls?.length) {
        <div class="flex items-center gap-2 flex-wrap">
          @for (file of content.documentUrls; track $index) {
            <app-content-document [file]="file" />
          }
        </div>
      }
    </div>
  </section>
}
